<template>
  <div class="col-sm-12 col-md-12">
    <div class="row m-t-20">
      <div class="col-lg-12">
        <h4 class="card-title" style="font-size: medium">
          {{ impactArea.name }}
        </h4>
        <hr>
      </div>
    </div>
    <div v-if="impactArea" class="row">
      <div class="col-lg-12">
        <p class="m-t-0">
          {{ impactArea.description }}
        </p>
        <div v-for="principle in impactArea.principles" :key="principle.principle">
          <principle :impact-area="impactArea.abbreviation" :principle="principle" :principle-index="principle.principle_index" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Principle from './Principle.vue';
export default {
  name: 'ImpactArea',
  components: { Principle },
  props: ['impactArea']
}
</script>

<style scoped>
</style>
